import ApiClient from './ApiClient'
import {RetailAndLogisticsContactModel} from '../types/Entities/RetailAndLogisticsType'


const getallregiondetails = async (apiClient: ApiClient) => {
  return apiClient
    .get<Array<RetailAndLogisticsContactModel>>(`SiteCareManager/getallregiondetails`)
    .catch(error => { throw error })
}


const RetailAndLogisticsApi = {
  getallregiondetails
}
export default RetailAndLogisticsApi